import { FALLBACK_FILENAME } from "./constants";

export function filenameFrom(disposition) {
    const match = disposition?.match(/filename="?([^"]+)"?/);

    return match?.[1] || FALLBACK_FILENAME;
}

export function saveBlob(response) {
    const url = window.URL.createObjectURL(response.data);
    const anchor = document.createElement("a");

    anchor.href = url;
    anchor.download = filenameFrom(response.headers["content-disposition"]);
    anchor.click();
    anchor.remove();

    // Revoking synchronously can cancel the download before the browser starts it.
    setTimeout(() => window.URL.revokeObjectURL(url), 1000);
}
